import {ReceiverDto, ShipmentListItemDto, ShipmentPackageItemDto, ShipmentPackageStatusDto} from "../../../api/fms";

interface Status {
    text: string
    cls: string
}

export function getShipmentListItemStatus (item: ShipmentListItemDto): Status {
    return item.status === ShipmentPackageStatusDto.CLOSED && !item.cancelled ? {
        cls: 'has-text-grey-light',
        text: 'Abgeschlossen'
    } : getStatus(item);
}

export function getStatus(item: ShipmentListItemDto | ShipmentPackageItemDto): Status {
    return item.lastScan ? {
            cls: '',
            text: 'Last Scan durchgeführt'
        } :
        item.lost ? {
                cls: 'has-text-warning',
                text: 'Nicht auffindbar'
            } :
            item.cancelled ? {
                    cls: 'has-text-grey-light',
                    text: 'Storniert'
                } :
                item.picklistId ? {
                        cls: 'has-text-primary',
                        text: 'Last Scan noch durchzuführen'
                    } :
                    item.ready ? {
                        cls: 'has-text-success-50',
                        text: 'Versandauftrag bereit'
                    } : {
                        cls: 'has-text-warning-40',
                        text: 'Versandauftrag angelegt'
                    }
}

export function formatAddressLine(receiver: ReceiverDto): string {
    let line = receiver.line1

    if(receiver.line2){
        line += `, ${receiver.line2}`;
    }

    const address = receiver.address

    line += `, ${address.street}`

    if (address.houseNumber) {
        line += ` ${address.houseNumber}`
    }

    line += `, ${address.postCode} ${address.city}, ${address.country}`

    return line
}